// Rotas de autenticação
export const AUTH_ROUTES = {
  LOGIN: '/login',
  LOGIN_TRAVEL_EXPERT: '/login/travel-expert',
  FORGOT_PASSWORD: '/forgot-password',
  LOGOUT: '/logout',
  REGISTER: '/register',
  GUIDE_REGISTER: '/guide/register',
};

// Rotas principais do sistema
export const SYSTEM_ROUTES = {
  ERROR: '/error',
  REDIRECTING: '/redirecting',
  NOT_ALLOWED: '/not-allowed',
  IN_PROGRESS: '/in-progress',
};

// Rotas de administração
export const ADMIN_ROUTES = {
  DASHBOARD: '/admin',
  ADVISOR: '/admin/advisor',
  PRICES: '/admin/prices',
  FAQ: '/admin/faq',
  NEWSLETTER: '/admin/newsletter',
  ORGANIZATIONS: '/admin/organizations',
  PARTNER_STATUS: '/admin/partner-status',
  REPORTS: '/admin/reports',
  REPORTS_LEADS: '/admin/reports/leads',
  REPORTS_ADVISORS: '/admin/reports/advisors',
  REPORTS_TRAVELERS: '/admin/reports/travelers',
  REPORTS_COMPLAINTS: '/admin/reports/complaints',
  REPORTS_ADVISOR: '/admin/reports/advisor',
};

// Rotas do mentor/advisor
export const MENTOR_ROUTES = {
  // HOME: '/advisor/home',
  HOME: '/travel-expert/home',
  AGENDA: '/advisor/agenda',
  PROFILE: '/advisor/profile',
  COMPLETE_PROFILE: '/travel-expert/complete-profile',
  SCHEDULED_TOURS: '/advisor/scheduled-tours',
  MEETING_RESUME: '/advisor/meeting-resume',
  RESUME: '/advisor/resume',
  RESUME_DOCUMENT: '/advisor/resume/:id/document',
  BRIEFING: '/advisor/briefing',
  TRAVEL_EXPERT_HOME: '/travel-expert/home',
  TRAVELER_LOG: '/advisor/traveler-log',
  PERFORMANCE: '/advisor/performance',
};

// Rotas do travel expert (v2)
export const TRAVEL_EXPERT_ROUTES = {
  HOME: '/travel-expert/home',
};

// Rotas do viajante/traveller
export const TRAVELLER_ROUTES = {
  HOME: '/home',
  PROFILE: '/profile',
  CHECKOUT: '/checkout',
  SEARCH_MENTOR: '/search-mentor',
  RESUME: '/resume',
  RESUME_DOCUMENT: '/resume/:id/document',
  PENDING_BRIEFINGS: '/pending-briefings',
  BRIEFING: '/briefing',
  HISTORY_CALLS: '/history-calls',
  CHAT: '/chat',
  TRAVELER_LOG: '/traveler-log',
};

// Rotas públicas (unlogged)
export const PUBLIC_ROUTES = {
  HOME: '/',
  HOME_V1: '/home-v1',
  ABOUT_US: '/about-us',
  ABOUT_US_LEGACY: '/about-us-legacy',
  FAQ: '/faq',
  TERMS_CONDITIONS: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy',
  ADVISOR_DETAILS: '/advisor-details',
  ADVISOR_DETAILS_BY_COUNTRY: '/advisor-details/:country/:name',
  SEARCH_ADVISOR: '/search-advisor',
  SEARCH_TRAVEL_EXPERT: '/search-travel-expert',
  TESTIMONIALS: '/testimonials',
};

// Rotas de gift card
export const GIFT_CARD_ROUTES = {
  GIFT_CARD: '/gift-card',
  CHECKOUT_GIFT: '/checkout-gift',
  GIFT_ADVISOR_PROFILE: '/gift-advisor-profile',
};

// Rotas de reunião/video call
export const MEETING_ROUTES = {
  MEET: '/meet/*',
  LOBBY: '/lobby',
};

// Rotas de OAuth
export const OAUTH_ROUTES = {
  CALENDAR_CALLBACK: '/calendar-callback',
};

// Rotas B2B
export const B2B_ROUTES = {
  TRAVEL_PARTNERS: '/travelpartners',
  TRAVEL_PARTNERS_JOIN: '/travelpartners/join',
  LOGIN: '/travelpartners/login',
  AGENCY_TERMS: '/travelpartners/terms',
  ADMIN: '/b2b/admin',
  AGENT: '/b2b/agent',
  AGENT_BOOKINGS: '/b2b/agent/bookings',
  AGENT_CHAT: '/b2b/agent/chat',
  AGENT_CHAT_DETAIL: '/b2b/agent/chat/:bookingId',
  AGENT_NEW_RESERVATION: '/b2b/agent/new-reservation',
  AGENT_BOOKING_DETAIL: '/b2b/agent/booking/:bookingId',
};

// Todas as rotas agrupadas por conveniência
export const ALL_ROUTES = {
  ...AUTH_ROUTES,
  ...SYSTEM_ROUTES,
  ...ADMIN_ROUTES,
  ...MENTOR_ROUTES,
  ...TRAVEL_EXPERT_ROUTES,
  ...TRAVELLER_ROUTES,
  ...PUBLIC_ROUTES,
  ...GIFT_CARD_ROUTES,
  ...MEETING_ROUTES,
  ...OAUTH_ROUTES,
  ...B2B_ROUTES,
};

// Helper functions para construir rotas com parâmetros
export const buildRoute = (route, params = {}) => {
  let builtRoute = route;
  Object.keys(params).forEach((key) => {
    builtRoute = builtRoute.replace(`:${key}`, params[key]);
  });
  return builtRoute;
};

// Exemplos de uso:
// buildRoute(ADMIN_ROUTES.ADVISOR_DETAIL, { id: '123' }) -> '/admin/advisor/123'
// buildRoute(TRAVELLER_ROUTES.RESUME, { id: '456' }) -> '/resume/456'

export default ALL_ROUTES;
